import React,{useRef, useState, useEffect} from "react";
import { Link, useParams } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, Badge } from "react-bootstrap";
import Select from "react-select";
import Footer from "../layouts/Footer";
import Sidebar from "../layouts/Sidebar";
import Header from "../layouts/Header";
import parse from 'html-react-parser';
import {projectPhaseColors} from "../data/ProjectStatusColor";
import vindrApi from "../utils/vindrapi";
import authApi from "../utils/authApi";

import CardOwner from "../layouts/CardOwner";
import DialogOwner from "../layouts/DialogOwner";
import UserMenu		from "../components/UserMenu";
//import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
 
//mapboxgl.accessToken = 'pk.eyJ1IjoiZXNwZW52aW5kciIsImEiOiJjbGZpOXoyamIyYW1wM3FuMXBidjlvcXl5In0.XDmLF8QmTyYR-PiDcnDFGQ';


export default function ProjectOwners() {

	const [pageTitle,setPageTitle]		= useState('List of Owners');
	const [editOwner,setEditOwner]		= useState(false); //displays save owner  dialog if true
	
	document.body.className="projectowners";
	
	/*
	options of the sort by select box
	*/
	const ownersSortOptions = [
		{label:"Name", value:"name"},
		{label:"Email", value:"email"}
	];
	const params								= useParams();
	
	const [orderBy, setOrder]					= useState('');
	const [needle, setNeedle]					= useState('');
	const [data,setData]						= useState([]);
	const [user,setUser]						= useState({});
	
	const getData = ()=>{ 
		

		
	
		Promise.all([vindrApi.getToken()])
		.then((res) => {
			
			const dataRequests = [
				vindrApi.getScenarioOwners(params.id, 0), //for now it's all main scenario
				vindrApi.getProject(params.id, 0), //for now it's all main scenario,
				authApi.getUser()

			];
			return Promise.all(dataRequests);
		}).then((res)=>{
			var responses = res.map((response) => {
				if(response.json)
					return response.json();
				return response;
			});
			return Promise.all(responses);
		}).then(function(responses) {
			
			var owners			= responses[0];
			var projectData		= responses[1];
			var user			= responses[2];
			
			setUser(user);
			
			setPageTitle(pageTitle + ' - ' + projectData.name);
			
			owners.map((item)=>{
				//cleanup some newline characters,etc from the names
				item.name = item.name.trim();
				if(item.email)
					item.email = item.email.trim();
				//
				//... other validation and cleanuup tasks can be added
			})
			document.title = process.env.REACT_APP_DOC_TITLE;
			setData(owners)
		});
	};
	
	const searchNeedle = (item) => {
		
		if(needle.length < 3)
			return true;
		
		/* we use search now, therefor the >-1 condition, eventualy we can use regexp for boolean and search ranking*/
		return 	(item.name && item.name.match(new RegExp(needle, "i"))) || 
			(item.email && item.email.match(new RegExp(needle, "i"))) || 
			(item.phone && item.phone.match(new RegExp(needle, "i"))) || 
			(item.address && item.address.match(new RegExp(needle, "i"))) || 
			(item.projects && item.projects.length && item.projects.map(a => a.name).join(" ").match(new RegExp(needle, "i")));
	}
	

	useEffect(()=>{
		getData();
	},[])		


	const renderOwners = ()=> {

		if(data && data.length>0 ) {
			
			if(orderBy.length !== 0){
				/*
				 sort code here
				 eventualy it will be necessary to change this if asc and desc become options
				*/
				data.sort((a, b) => {
					if(!a[orderBy])
						return 1;
					if(!b[orderBy])
						return -1;
					return a[orderBy] && a[orderBy].toLowerCase().localeCompare(b[orderBy].toLowerCase());
				});
			}





			return data.map((item, index)=>{


				/* lets highlight the text users search, for usability */
				
				let phone = '';
				let address = '';
				let email = '';
				let projects = '';


				//if(item.projects && item.projects.length)
				//	projects = item.projects.map((a) => {return (<Link to={"/pages/project/" + a.id}><Badge className="me-1" bg={projectPhaseColors.get(a.status)}>{parse(a.name.replace(new RegExp(needle, "i"), highlight))}</Badge></Link>)})
				



				if(searchNeedle(item)){
					return (

						<CardOwner key={index} owner={item} onEdit={(e)=>setEditOwner(item)} needle={needle}  />
					)
				}
			});
		}
	}

	return (
		<React.Fragment>
			<div className="header">
			
				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>
				
                <Link to="/" className="header-logo">Site Planner</Link>
				
				<div className="middle">
					

					
				</div>
				<div className="options">
						{user.userId && <UserMenu user={user} onUpdateUser={setUser} />}
						
				</div>
			</div>
			
			<div className="body">
				<Sidebar />
				<div className="main p-4 p-lg-5">
					<Row>
						<Col xl>

							<Row className="g-3 pb-4">
								<Col xs="2" className="text-end pt-2">Search</Col>
								<Col xs="4"><Form.Control className="mb-2" type="text" onChange={(a)=>{if(a.target.value.length>2 || !a.target.value.length) setNeedle(a.target.value)}} placeholder="name, email, phone, project, address" /></Col>
								<Col xs="2" className="text-end pt-2">Sort By</Col>
								<Col xs="4"><Select options={ownersSortOptions} onChange={(a)=>{setOrder(a.value)}} /></Col>
							</Row>
							<Row className="g-3">{renderOwners()}</Row>
						</Col>
					</Row>
					<DialogOwner owner={editOwner} onClose={()=>{setEditOwner(false)}} />
					<Footer />
				</div>

			</div>
			
		</React.Fragment>
	);
}
